"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var common_1 = require("stremio/common");
var hat_1 = __importDefault(require("hat"));
var MAX_TRIES = 25;
var useSocialLogin = function (_a) {
    var loginUrl = _a.loginUrl, getCredentials = _a.getCredentials, interval = _a.interval, errorMessage = _a.errorMessage;
    var openExternal = (0, common_1.usePlatform)().openExternal;
    var currentAttempt = (0, react_1.useRef)(null);
    var stop = (0, react_1.useCallback)(function () {
        var attempt = currentAttempt.current;
        currentAttempt.current = null;
        if (attempt === null || attempt === void 0 ? void 0 : attempt.timeout) {
            clearTimeout(attempt.timeout);
        }
    }, []);
    var start = (0, react_1.useCallback)(function () {
        stop();
        return new Promise(function (resolve, reject) {
            var attempt = { timeout: null };
            currentAttempt.current = attempt;
            var state = (0, hat_1.default)(128);
            var tries = 0;
            openExternal("".concat(loginUrl, "/").concat(state));
            var waitForCredentials = function () {
                if (currentAttempt.current !== attempt) {
                    return;
                }
                attempt.timeout = setTimeout(function () {
                    if (tries >= MAX_TRIES) {
                        currentAttempt.current = null;
                        reject(new Error(errorMessage, { cause: 'Number of allowed tries exceeded!' }));
                        return;
                    }
                    tries++;
                    getCredentials(state)
                        .then(function (credentials) {
                        if (currentAttempt.current === attempt) {
                            currentAttempt.current = null;
                            resolve(credentials);
                        }
                    })
                        .catch(waitForCredentials);
                }, interval);
            };
            waitForCredentials();
        });
    }, [stop, openExternal, loginUrl, getCredentials, interval, errorMessage]);
    (0, react_1.useEffect)(function () { return stop; }, [stop]);
    return [start, stop];
};
exports.default = useSocialLogin;
